import React from 'react';
import {useNavigate} from "react-router-dom";
import ListVpsPage from "../ListVpsPage";

const AdminPageListVps = () => {
    const navigate = useNavigate();

    let redirectChangeUser = (listVpsId) => {
        navigate('/admin/vps/chuyen-khach-hang.html?' + listVpsId);
    }

    let redirectExportExcel = (listVps) => {
        navigate('/admin/vps/xuat-file-excel.html?' + listVps);
    }

    return <ListVpsPage
        redirectChangeUser={ (listVpsId) => redirectChangeUser(listVpsId) }
        redirectExportExcel={ (listVps) => redirectExportExcel(listVps) }
    />

}

export default AdminPageListVps;